import { db } from 'utils';
import { getSelectedConv, getUser } from 'selectors';
import { USER_MSG_TYPES as TYPES } from 'constants';
const emojiRegex = require('emoji-regex');

export const baseTemplate = (increment, text) => {
  const { id, name, photo } = getUser();
  const { total_msg, order } = getSelectedConv() || {};
  const is_emoji = isEmoji(text);
  let temp = {
    created: db.time(),
    id: db.key(),
    text: text ? text.trim() : null,
    parsed: isParsable(text) ? true : null,
    emoji: is_emoji ? is_emoji : null,
    index: total_msg + (increment || 1),
    user: { id, name, order: order || null, photo }
  };

  return temp;
};

export const textTemplate = ({ text, increment }) => baseTemplate(increment, text);

export const locationTemplate = ({ text, data, increment }) => {
  let temp = {
    ...baseTemplate(increment),
    type: TYPES.LOCATION,
    text,
    data
  };

  return temp;
};

export const contactTemplate = ({ text, data, increment }) => {
  const type = TYPES.CONTACT;
  let temp = {
    ...baseTemplate(increment, text),
    type,
    data
  };

  return temp;
};

export const uploadTemplate = ({ text, upload_type, data, increment }) => {
  const type = TYPES.UPLOAD;
  const base_msg = baseTemplate(increment, text);
  let temp = {
    ...base_msg,
    upload_type,
    data,
    type
  };

  return temp;
};

export const reg = {
  url: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/i,
  tel: /\d{7,}([^\S]|$)|\+\d{7,}([^\S]|$)/,
  email: /\S+@\S+\.\S+/
};

const isParsable = text => text && (RegExp(reg.url).test(text) || RegExp(reg.tel).test(text) || RegExp(reg.email).test(text));

const isEmoji = text => {
  if (text && text.length < 7) {
    const match = text.match(emojiRegex());
    if (match && match.length === text.length / 2) {
      return match.length;
    }
    return null;
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/utils/template.js